import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { UnitConverter } from '/@/core/units';
import { getSessionBrands, getSessionLanguage, getSessionUnits } from '/@/store/session/selectors';

export const useUnitProvider = (props = {}) => {
    const units = useSelector((state) => (props.units ? props.units : getSessionUnits(state)));
    const language = useSelector((state) => (props.language ? props.language : getSessionLanguage(state)));
    const brands = useSelector((state) => (props.brands ? props.brands : getSessionBrands(state)));

    // Add a version counter to force re-creation of the UnitConverter when dependencies change
    const unitVersion = useMemo(() => JSON.stringify({ units, language, brands }), [units, language, brands]);

    const unit = useMemo(
        () =>
            new UnitConverter({
                ...units,
                language,
                brands,
            }),
        // Include unitVersion in dependencies to ensure the UnitConverter is recreated when any dependency changes
        [unitVersion]
    );

    return unit;
};

export default useUnitProvider;
